import * as aboutActions from "../actions/about.actions"
import { AboutModel } from "../models/about-model";

// NB: We will porentially need per widget instance state, not addressed here
// or this may be handled by the various filters

export interface State {
  aboutDetails: AboutModel;
  versionNumber: string;
  loading: boolean;
  error: string;
  loaded: boolean;
}

export const INITIAL_STATE: State = {
  aboutDetails: undefined,
  versionNumber: undefined,
  loading: false,
  error: undefined,
  loaded: false,
}

export function reducer(state: State = INITIAL_STATE, action: aboutActions.Actions) {
  var errorMessage: string;

  switch (action.type) {
    case aboutActions.LOAD:
      {
        return {
          ...state,
          error: undefined,
          loading: true
        } as State;
      }
    case aboutActions.LOAD_COMPLETE:
    {
      return {
        ...state,
        error: undefined,
        loading: false,
        aboutDetails: action.payload,
        versionNumber: action.versionNumber,
        loaded: true
    } as State;
      }
    case aboutActions.LOAD_ERROR:
      {
        errorMessage = '';
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }

        return {
          ...state,
          error: errorMessage,
          loading: false,
          aboutDetails: undefined,
          loaded: false
        } as State;
      }

    default:
      {
        return state;
      }
  }
}
